module.exports = __webpack_public_path__ + "img/survey_kepuasan_lg.2ec77a3f.png";